import { Controller } from "@hotwired/stimulus"

const FORMAT = /[^a-z0-9_]/gi
const MIN_LENGTH = 3

export default class extends Controller {
  static targets = ["input", "preview", "submit"]

  connect() {
    this.update()
  }

  sanitize() {
    const sanitized = this.inputTarget.value.replace(FORMAT, "").toLowerCase()
    if (sanitized !== this.inputTarget.value) this.inputTarget.value = sanitized
    this.update()
  }

  update() {
    const value = this.inputTarget.value
    if (this.hasPreviewTarget) {
      this.previewTarget.textContent = value || this.previewTarget.dataset.placeholder || "seunome"
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = value.length < MIN_LENGTH
    }
  }
}
